"use strict";

module.exports = function () {
    var state = {
        page: 1,
        query: this.query,
        orderBy: this.orderBy,
        perPage: this.opts.perPage,
        customQueries: this.customQueries
    };

    this.storage.setItem(this.stateKey, JSON.stringify(state));

    return state;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/init-state.js
// module id = 254
// module chunks = 0